import type { MonthlyCollectsByOrigin } from '@/integrations/agreements/client';

export const COLLECTS_BY_ORIGIN_SERIES = [
  {
    key: 'recurring_count',
    label: 'Recorrentes',
    /** `primary-500` do DS. Hex porque `fill` do Recharts é atributo SVG e não
     *  aceita classe Tailwind — mesma razão de RANKED_MATERIAL_PALETTE. */
    color: '#8aa5ff',
    swatchClassName: 'bg-primary-500',
  },
  {
    key: 'on_demand_count',
    label: 'Coletas sob demanda',
    /** `secondary-500` do DS. */
    color: '#ffba86',
    swatchClassName: 'bg-secondary-500',
  },
] as const;

export type CollectsByOriginSeriesKey =
  (typeof COLLECTS_BY_ORIGIN_SERIES)[number]['key'];

/**
 * True quando não houve nenhuma coleta em nenhum dos meses.
 *
 * Não confundir com erro: aqui a resposta chegou, só não tem o que mostrar. E
 * não confundir com "mês zerado" — um mês vazio no meio da série continua
 * desenhando a coluna, senão a comparação mês a mês fica torta.
 */
export function isCollectsByOriginEmpty(
  entries: MonthlyCollectsByOrigin[],
): boolean {
  return entries.every(
    (entry) => entry.recurring_count === 0 && entry.on_demand_count === 0,
  );
}
